import React, { useState, useEffect } from "react";

interface FeedbackModalProps {
    show: boolean;
    onClose: () => void;
    onSubmit: (feedback: string, rating: 'positive' | 'negative') => void;
    rating: 'positive' | 'negative';
    title: string;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
    show,
    onClose,
    onSubmit,
    rating,
    title
}) => {
    const [feedback, setFeedback] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [show]);

    const handleSubmit = async () => {
        if (!feedback.trim()) return;
        
        setIsSubmitting(true);
        try {
            await onSubmit(feedback, rating);
            setFeedback("");
            onClose();
        } catch (error) {
            console.error("Error submitting feedback:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setFeedback("");
        onClose();
    };

    return (
        <>
            {show && (
                <div
                    className="modal-overlay"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 999,
                    }}
                ></div>
            )}

            <div
                className="modal card fadeIn"
                style={{
                    display: show ? "block" : "none",
                    position: "fixed",
                    maxWidth: "43.22vw",
                    height: "40vh",
                    maxHeight: "50vh",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    border: "1px solid #dee2e6",
                    borderRadius: "1.875rem",
                    overflow: "hidden"
                }}
            >
                <div className="modal-header mx-4" style={{
                    borderBottomColor: '#5376F0'
                }}>
                    <h5 className="modal-title" style={{
                        color: '#26397E',
                        fontSize: '1.625rem',
                        fontWeight: 'bold'
                    }}>{title}</h5>
                </div>
                <div 
                    className="modal-body py-4"
                    style={{
                        height: "calc(35vh - 120px)",
                        overflowY: "auto"
                    }}
                >
                    <div className="mb-3" style={{
                        paddingLeft: '1.5rem',
                        paddingRight: '1.5rem'
                    }}>
                        <label htmlFor="feedback" className="form-label" style={{
                            fontSize: '0.875rem',
                        }}>
                            Your feedback helps us improve our responses:
                        </label>
                        <textarea
                            name="feedback"
                            className="form-control bg-white"
                            rows={4}
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            // placeholder="Please share your thoughts..."
                            // style={{
                            //     border: '1px solid #dee2e6',
                            //     borderRadius: '0.5rem',
                            //     padding: '0.75rem',
                            //     fontSize: '0.9rem',
                            //     resize: 'vertical',
                            //     minHeight: '100px'
                            // }}
                        />
                    </div>
                </div>
                <div className="modal-footer d-flex flex-row align-items-center justify-content-center gap-2 px-4 pb-3" style={{
                    border: 'none',
                    paddingBottom: '1.5rem'
                }}>
                    <button 
                        className="btn btn-rounded btn-confirmation clr-black btn-confirmation-cancel"
                        onClick={handleClose}
                        disabled={isSubmitting}
                        style={{
                            width: '32%', 
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#5376F0 !important';
                            target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#ABCAFF !important';
                            target.style.transform = 'translateY(0)';
                        }}
                    >
                        CANCEL
                    </button>
                    <button 
                        className="btn btn-rounded-blue btn-confirmation"
                        onClick={handleSubmit}
                        disabled={!feedback.trim() || isSubmitting}
                        style={{
                            width: '32%', 
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#5376F0 !important';
                            target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#ABCAFF !important';
                            target.style.transform = 'translateY(0)';
                        }}
                    >
                        {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default FeedbackModal; 